import { observer } from 'mobx-react';
import StringInput from '../../../../../../Resource/FormTemplates/Inputs/StringInput';
import WithField from '../../../../../../Resource/FormTemplates/Inputs/WithField';
import { T } from '../../../../../../Translations';
import { EitherLearningCollectionStore } from '../../../../Types';
import S3ImageUpload from './S3ImageUpload';
import { UploadImageStore } from './UploadImageStore';

interface Props {
  store: EitherLearningCollectionStore;
  uploadImageStore: UploadImageStore;
}

function Form({ store, uploadImageStore }: Props) {
  return (
    <div data-intercom-target="learning-collection-details-form">
      <h3
        className="mb-6 text-3xl font-semibold"
        data-intercom-target="describe-your-collection-heading"
      >
        <T kind="Describe your collection" />
      </h3>
      <div className="lg:flex lg:justify-between">
        <div className="w-full grow lg:w-[58%]">
          <p className="text-gray-700" data-intercom-target="collection-form-instructions">
            <T kind="Create a title and..." />
          </p>
          <div className="mt-4">
            {store.template
              .map((template) => (
                <>
                  <div className="flex w-full flex-col lg:flex-row">
                    <div
                      className="w-full lg:w-3/5"
                      data-intercom-target="collection-name-fields-section"
                    >
                      <WithField kind="string" name="name" fields={template.fields}>
                        {(field) => <StringInput field={field} />}
                      </WithField>
                    </div>
                    <div
                      className="ml-0 w-full lg:ml-6 lg:w-2/5"
                      data-intercom-target="collection-internal-name-field-section"
                    >
                      <WithField kind="string" name="internal_name" fields={template.fields}>
                        {(field) => <StringInput field={field} optional />}
                      </WithField>
                    </div>
                  </div>
                  <div className="flex w-full flex-col lg:flex-row">
                    <div
                      className="w-full lg:w-3/5"
                      data-intercom-target="collection-description-section"
                    >
                      <WithField kind="string" name="description" fields={template.fields}>
                        {(field) => <StringInput field={field} />}
                      </WithField>
                    </div>
                    <div
                      className="ml-0 w-full lg:ml-6 lg:w-2/5"
                      data-intercom-target="collection-image-upload-section"
                    >
                      <S3ImageUpload links={store.links} uploadImageStore={uploadImageStore} />
                    </div>
                  </div>
                </>
              ))
              .getOrElse(() => (
                <></>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(Form);
